import Image from "components/Image"
import ListStar from "components/ListStar";
import { RattingCommentItemWrapper } from "./styled"
import { useDispatch, useSelector } from "react-redux";
import { authSelector, rattingCommentSelector } from "redux/selector";
import { useMemo } from "react";
import ReplyForm from "../ReplyForm";
import { useState } from "react";
import Tippy from '@tippyjs/react/headless';
import { role } from "common/general";
import Modal from "components/Modal";
import FormStarRating from "components/FormStarRating";
import Button from "components/Button";
import { rattingCommentActions } from "redux/slice/rattingCommentSlice"
import RattingReplyItem from "../RattingReplyItem/RattingReplyItem";


const RattingCommentItem = ({ data, isReply = false, callBack }) => {
    const rattingState = useSelector(rattingCommentSelector)
    const [seeMore, setSeeMore] = useState(false)
    const authState = useSelector(authSelector)
    const [rattingControl, setRattingControl] = useState(false);
    const [rattingReplyControl, setRattingReplyControl] = useState(false);
    const [showModal, setShowModal] = useState(false)
    const [method, setMethod] = useState("edit")
    const [type, setType] = useState(0)
    const [numberStar, setNumberStar] = useState(5)
    const [dataRatting, setDataRatting] = useState()
    const [content, setContent] = useState("")
    const dispatch = useDispatch()
    const [errorContent, setErrorContent] = useState("")

    const replyList = useMemo(() => {
        if (rattingState.rattingData.length > 0 && data.id) {
            return rattingState.rattingData.filter(item => item.parent_id === data.id)
        }
        return []
    }, [data.id, rattingState.rattingData])

    const checkShowModalControl = (id) => {
        if (authState.isLoggedIn && (authState.role === role.ADMIN || authState.role === role.STAFF || authState.currentUser?.user?.account_id === id))
            return true
        return false
    }


    const checkEdit = (id) => {
        if (authState.isLoggedIn && (authState.currentUser?.user?.account_id === id))
            return true
        return false
    }

    const checkAdmin = useMemo(() => {
        if (authState.isLoggedIn && (authState.role === role.ADMIN || authState.role === role.STAFF))
            return true
        return false
    }, [authState.isLoggedIn, authState.role])

    const title = useMemo(() => {
        if (type === 0) {
            if (method === "edit")
                return "Chỉnh sửa đánh giá"
            if (method === "remove")
                return "Xóa đánh giá"
            if (method === "block")
                return "Ẩn đánh giá"
        }
        if (type === 1) {
            if (method === "edit")
                return "Chỉnh sửa Bình luận"
            if (method === "remove")
                return "Xóa Bình luận"
            if (method === "block")
                return "Ẩn Bình luận"
        }
        return ""
    }, [method, type])


    const handleRemove = () => {
        dispatch(rattingCommentActions.removeRatting({ id: dataRatting.id, callBack }))
        setShowModal(false)
    }

    const handleUpdate = () => {
        const payload = {
            content: content.trim(),
            star: numberStar
        }
        if (type === 0) {
            dispatch(rattingCommentActions.updateRatting({ id: dataRatting.id, data: payload, callBack }))
            setShowModal(false)
            setErrorContent("")
        }
        if (type === 1) {
            if (content.trim().length > 12) {
                dispatch(rattingCommentActions.updateRatting({ id: dataRatting.id, data: payload, callBack }))
                setShowModal(false)
                setErrorContent("")
            } else {
                setErrorContent("Vui lòng nhập bình luận tối thiểu 12 ký tự")
            }
        }
    }
    const handleBlock = () => {
        const payload = {
            status: 1,
        }
        dispatch(rattingCommentActions.blockRatting({ id: dataRatting.id, data: payload, callBack }))
        setShowModal(false)
    }

    return (
        <RattingCommentItemWrapper>
            <div className="header flex header_list">
                <div className="image b-grey-1">
                    <Image src={data.avatar} />
                </div>
                <div className="info ml-10">
                    <div className="text-black medium s-18">{data.full_name || "No Name"}
                        <span className="text-red s-14">{data.permission === 0 ? " - Quản trị viên" : data.permission === 1 ? " - Nhân viên" : " - Khách hàng"}</span>
                    </div>
                    <span className="text-grey s-14">{data.created_at.slice(0, 10)}</span>
                    {
                        !isReply &&
                        <ListStar star={data.star} />
                    }
                </div>
                <Tippy
                    interactive
                    placement='bottom'
                    visible={authState.isLoggedIn && rattingControl}
                    onClickOutside={() => setRattingControl(!rattingControl)}
                    render={attrs => (
                        <div
                            className="rating_comment_control_box b-grey-1 bg-white"
                        >
                            {
                                checkEdit(data.account_id) &&
                                <>
                                    <span
                                        className="text-black px-10 clickable"
                                        onClick={() => {
                                            setShowModal(true)
                                            setMethod("edit")
                                            setType(0)
                                            setNumberStar(data.star)
                                            setDataRatting(data)
                                            setContent(data.content)
                                            setRattingControl(!rattingControl)
                                        }}
                                    >
                                        Chỉnh sửa
                                    </span>
                                    {/* <span
                                        className="text-black px-10 clickable"
                                        onClick={() => {
                                            setShowModal(true)
                                            setMethod("remove")
                                            setType(0)
                                            setNumberStar(data.star)
                                            setDataRatting(data)
                                            setContent(data.content)
                                            setRattingControl(!rattingControl)
                                        }}
                                    >
                                        Xóa
                                    </span> */}
                                </>
                            }
                            {
                                checkAdmin &&
                                <span
                                    className="text-black px-10 clickable"
                                    onClick={() => {
                                        setShowModal(true)
                                        setMethod("block")
                                        setType(0)
                                        setNumberStar(data.star)
                                        setDataRatting(data)
                                        setContent(data.content)
                                        setRattingControl(!rattingControl)
                                    }}
                                >
                                    Ẩn đánh giá
                                </span>
                            }

                        </div>
                    )}
                >
                    <div className="rating_comment_control">
                        {
                            checkShowModalControl(data.account_id) &&
                            <i
                                onMouseEnter={() => setRattingControl(!rattingControl)}
                                className="ti-more-alt"
                            ></i>
                        }
                    </div>
                </Tippy>
            </div>
            {
                data.content &&
                <div className="content">
                    <div className="text-black s-16 word-break pre-line">{data.content}</div>
                </div>
            }
            <ReplyForm data={data} replyList={replyList} callBack={callBack} seeMore={seeMore} setSeeMore={setSeeMore} />
            {
                replyList.length > 0 && seeMore &&
                <ul className="reply_list">
                    {
                        replyList.map((item, index) => (
                            <li key={index} className="mt-10 reply_item bt-grey2-1 pt-10 pl-10 ml-10">
                                <RattingReplyItem
                                    item={item}
                                    checkEdit={checkEdit}
                                    setShowModal={setShowModal}
                                    setMethod={setMethod}
                                    setType={setType}
                                    setNumberStar={setNumberStar}
                                    setDataRatting={setDataRatting}
                                    setContent={setContent}
                                    checkAdmin={checkAdmin}
                                    checkShowModalControl={checkShowModalControl}
                                    callBack={callBack}
                                />
                            </li>
                        ))
                    }
                </ul>
            }
            {
                showModal &&
                <Modal onClose={() => setShowModal(false)}>
                    <div className="p-15 modal_ratting">
                        <div className="text-black pb-5 bb-grey-1 text-center medium s-18">
                            {title}
                        </div>
                        <div>
                            {
                                type === 0 &&
                                <div className="flex">
                                    <FormStarRating
                                        numberStar={numberStar}
                                        setNumberStar={setNumberStar}
                                    />
                                </div>
                            }
                            <textarea
                                readOnly={method === "edit" ? false : true}

                                className="form_content p-5 mt-20" value={content} onChange={(e) => setContent(e.target.value)}></textarea>
                            <p className="text-red ">{errorContent}</p>
                        </div>
                        <div className="flex-end px-15 mt-20">
                            <div>
                                {
                                    method === "edit" &&
                                    <Button className="action-danger-1"
                                        onClick={handleUpdate}
                                    >{title}</Button>
                                }
                                {
                                    method === "remove" &&
                                    <Button className="action-danger-1" onClick={handleRemove}>{title}</Button>
                                }
                                {
                                    method === "block" &&
                                    <Button className="action-danger-1" onClick={handleBlock}>{title}</Button>
                                }
                            </div>
                            <div>
                                <Button className="action-primary ml-10" onClick={() => setShowModal(false)}>Thoát</Button>
                            </div>
                        </div>
                    </div>
                </Modal>
            }

        </RattingCommentItemWrapper>
    )
}

export default RattingCommentItem